module.exports = "pegasus_template/assets/tech/safari/100.png";